<template>
    <div class="mx-auto">
        <b-modal
            id="modal-enviar-email"
            :content-class="'shadow ' + getTheme"
            header-bg-variant="success"
            header-text-variant="white"
            ref="modal-enviar-email"
            size="xl"
            title="Enviar por E-mail"
        >
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <div id="messages" v-if="messageModal.message !== null">
                        <b-alert show :variant="messageModal.variant">{{ messageModal.message }}</b-alert>
                    </div>
                </b-col>
                <b-col xs="12" md="12" class="mx-auto">
                    <b-row class="mt-1 mb-0">
                        <b-col sm="12" md="12">
                            <b-form-group
                                label="Enviar:"
                                label-cols-sm="2"
                                label-cols-lg="1"
                                label-for="option"
                                class="text-label font-weight-bold"
                            >
                                <b-form-checkbox
                                    id="enviarBoletosPendentes"
                                    v-model="enviarBoletosPendentes"
                                    v-show="isFormaPagamentoBoleto"
                                    :disabled="boletoPendenteVazio"
                                >
                                    boletos(s) pendentes(s)
                                </b-form-checkbox>
                                <b-form-checkbox
                                    id="enviarAnexos"
                                    v-model="enviarAnexos"
                                    :disabled="anexos.length === 0"
                                >
                                    documento(s) anexado(s) à Requisição
                                </b-form-checkbox>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3 mb-0">
                        <b-col sm="9" md="9">
                            <b-form-group
                                label="Para as contas de e-mail:"
                                label-cols-sm="3"
                                label-cols-lg="3"
                                label-for="emails"
                                class="text-label font-weight-bold"
                                
                                
                            >
                                <b-form-input
                                    id="emails"
                                    v-model="emails"
                                    data-vv-as="E-mails"
                                    type="text"
                                    :class="'text-label required ' + (!paymentValidations.email.valid ? 'is-invalid' : '')">
                                ></b-form-input>
                                
                                <b-row>
                                    <b-col sm="12" md="12">
                                    <div v-if="!paymentValidations.email.valid" class="invalid-message font-weight: normal "> Campo Obrigatório.</div>
                                   </b-col>
                                   </b-row>
                                   
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="limparValidacao"> <i class="fa fa-times"></i> Cancelar</b-button>
                <b-button variant="primary" @click="enviarEmail" class="mr-2" title="Enviar boleto e documentação ao devedor"> <i class="far fa-paper-plane"></i> Enviar</b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import axios from 'axios'
    import formatarMixins from '../../../mixins/formatarMixins'

    export default {
    props: [ 'loading', 'anexos' ],
    mixins: [ formatarMixins ],
    data () {
        return {
            FORMA_PAGAMENTO_BOLETO: 'Boleto',
            urlApi: null,
            token: null,
            boletoPendenteVazio: false,
            emails: null,
            enviarAnexos: false,
            enviarBoletosPendentes: true,
            resultado: null,
            messageModal: {
                message: null,
                variant: null
                
            },
            paymentValidations: {
                    email: { valid: true, message: ""}
                   
                    
                },
        }
        
        
    },
    
    
    computed: {
        getTheme () {
            return this.$store.getters.getTheme
        },
        isFormaPagamentoBoleto () {
            return ((this.resultado) && (this.resultado.formaPagamento === this.FORMA_PAGAMENTO_BOLETO))
        }
    },
    methods: {
        abrirModalEnviarEmail (resultado) {
            this.resultado = resultado

            if ((this.resultado.parcelas) && (this.resultado.parcelas.some((parcela) => parcela.situacao === "Pendente"))) {
                this.boletoPendenteVazio = false
                this.enviarBoletosPendentes = true
            } else {
                this.boletoPendenteVazio = true
                this.enviarBoletosPendentes = false
            }

            this.limparMsgsModal()
            this.$refs['modal-enviar-email'].show()
        },
        enviarEmail () {
            if (!this.validarValorObrigatorio(this.emails)) {
                return
            }

            let parametros = {
                emails: this.emails,
                enviarAnexos: this.enviarAnexos,
                enviarBoletosPendentes: this.enviarBoletosPendentes
            }

            this.loading.showLoading()
            axios.post(`${this.urlApi}/v1/pesquisas/enviarEmail/${this.resultado.tipoOrigem}/${this.resultado.id}`, parametros, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then((response) => {
                this.$refs['modal-enviar-email'].hide()
                this.$emit('enviarEmailSucesso', response)
                this.loading.hideLoading()
                this.limparValidations(this.paymentValidations);
                
            }).catch((error) => {
                if (error.response != null && error.response.data != null) {
                    this.messageModal = {
                        message: error.response.data,
                        variant: 'danger'
                    }
                } else {
                    this.messageModal = {
                        message: error,
                        variant: 'danger'
                    }
                }
                this.loading.hideLoading()
                this.limparValidations(this.paymentValidations);
                
            })
        },
        
        
        validarValorObrigatorio() {
                
                if(this.emails == "" | this.emails == null) {
                    this.validarCampoObrigatorio(this.emails, this.paymentValidations.email)
                    return this.paymentValidations.email.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.email.valid=true;
                    
                }
                
                this.limparValidations(this.paymentValidations);
            },
            
         limparValidacao() {
            
               this.limparValidations(this.paymentValidations);
               this.hideModal('modal-enviar-email');
            },
               
        limparMsgsModal() {
            this.messageModal = {
                message: null,
                variant: null
            };
        },
        verificarObrigatoriedade() {
            return !(this.verificarValorVazio(this.emails))
        }
    },
    mounted() {
        this.urlApi = process.env.VUE_APP_ROOT_API
        this.token = JSON.parse(this.$store.getters.getUser).access_token
    },
    watch: {
        resultado: function (newVal) {
            let emails = []
            if ((newVal) && (newVal.contribuinte)) {
                if (newVal.contribuinte.email) {
                    emails.push(newVal.contribuinte.email)
                }
                if (newVal.contribuinte.emailAlternativo1) {
                    emails.push(newVal.contribuinte.emailAlternativo1)
                }
                if (newVal.contribuinte.emailAlternativo2) {
                    emails.push(newVal.contribuinte.emailAlternativo2)
                }
            }
            this.emails = emails.join(', ')
        }
    }
}
</script>

<style scoped>

.no-line {
    white-space: nowrap;
}

</style>
